import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Icon_arrow from "../../assets/images/icons/arrow-right.svg";
import Icon_price from "../../assets/images/icons/bank-note-dark.svg";
import success from "../../assets/images/icons/check-contained.svg";
import Icon_clinic_schedule from "../../assets/images/icons/clock-dark.svg";
import Icon_doctor_specialty from "../../assets/images/icons/file-text.svg";
import Icon_clinic_address from "../../assets/images/icons/marker.svg";
import pendingIcon from "../../assets/images/icons/pending.svg";
import icon_contact_info from "../../assets/images/icons/phone-dark.svg";
import personal_info from "../../assets/images/icons/profile-dark.svg";
import { Drawer } from "../../components";
import { useGetPersonalInfo } from "../../hooks";

interface CompleteProfileProps {
  isOpen: boolean;
  onClose: () => void;
}
const CompleteProfile: React.FC<CompleteProfileProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: userData } = useGetPersonalInfo();

  const personalData = userData?.Data;

  const items = [
    {
      icon: Icon_clinic_schedule,
      label: t("clinic_schedule"),
      appear: personalData?.CompleteScheduleInfo,
      link: "/profile/clinic_schedule/add",
    },
    {
      icon: Icon_clinic_address,
      label: t("clinic_address"),
      appear: personalData?.CompleteAddresstInfo,
      link: "/profile/clinic_address/edit",
    },
    {
      icon: icon_contact_info,
      appear: personalData?.CompleteContactInfo,
      label: t("contact_info"),
      link: "/profile/contact_info/edit",
    },
    {
      icon: personal_info,
      label: t("personal_info"),
      appear: personalData?.CompletePersonalInfo,
      link: "/profile",
    },
    {
      icon: Icon_price,
      label: t("session_price"),
      appear: personalData?.CompleteTarrifInfo,
      link: "/profile/price/edit",
    },
  ];

  return (
    <>
      <Drawer
        isOpen={isOpen}
        header={t("complete_profile")}
        customStyle="w-96 !px-4 !overflow-auto !gap-0"
        headerCustomStyle="!py-4"
        onClose={() => {
          onClose();
        }}
      >
        <div className="h-fit rounded-lg border border-systemBg bg-input-field p-4">
          <div className={`flex items-center justify-between gap-2`}>
            <div className="flex items-center gap-2">
              <img
                src={Icon_doctor_specialty}
                alt={t("document")}
                className="h-6 w-6"
              />
              <p className="text-sm">{t("document_status")}</p>
            </div>

            {!personalData?.CompleteSpecialtyInfo ? (
              <div className={`flex items-center gap-2 text-orange`}>
                <img src={pendingIcon} alt="pending" />
                <span className="text-sm font-bold">{t("pending")}</span>
              </div>
            ) : (
              <div className={`flex items-center gap-2 text-successGreen`}>
                <img src={success} alt={"verified"} />
                <span className="text-sm font-bold">{t("completed")}</span>
              </div>
            )}
          </div>
        </div>
        {items.map((e, i) => (
          <div
            key={i}
            className="h-fit rounded-lg border border-systemBg bg-input-field p-4"
          >
            <div className={`flex items-center justify-between gap-2`}>
              <div className="flex items-center gap-2">
                <img src={e.icon} alt={e.label} className="h-6 w-6" />
                <p className="text-sm">{e.label}</p>
              </div>
              {e.appear && (
                <div className="flex items-center gap-2">
                  <img src={success} alt="success" className="h-6 w-6" />
                  <p className="text-sm font-bold text-successGreen">
                    {t("completed")}
                  </p>
                </div>
              )}
            </div>
            {!e.appear ? (
              <button
                type="button"
                title={t("complete")}
                onClick={() => navigate(e.link)}
                className="mt-4 flex h-10 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-primary bg-primary-bg py-2 text-sm font-bold text-primary"
              >
                {t("complete")}
                <span className="rtl:rotate-180">
                  <img src={Icon_arrow} alt="arrow" />
                </span>
              </button>
            ) : (
              <></>
            )}
          </div>
        ))}
      </Drawer>
    </>
  );
};

export default CompleteProfile;
